module.exports = __webpack_public_path__ + "static/img/icon5.ba3b8b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon5.png
// module id = B+sa
// module chunks = 11